import { HeadPosition } from 'modules/onboarding/common/components';

import { useHeadPosition } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const HeadPositionStep = ({ canGoBack }: PageComponentProps) => {
  const {
    bodies,
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onSubmit,
    onAddFiles,
    onRemoveFile,
    goToBack,
  } = useHeadPosition();

  const { step } = useOnboardingContext();

  return (
    <HeadPosition
      bodies={bodies ?? []}
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
